/* ErrorTemplate.styles.ts generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _26 = "._19pkv47k{margin-top:var(--ds-space-250,20px)}";
const _25 = "._1wyb1j6v{font-size:1rem}";
const _24 = "._ca0qu2gc{padding-top:var(--ds-space-100,8px)}";
const _23 = "._ca0qv47k{padding-top:var(--ds-space-250,20px)}";
const _22 = "._1dyznl7k{letter-spacing:.3px}";
const _21 = "._18u0idpf{margin-left:0}";
const _20 = "._otyridpf{margin-bottom:0}";
const _19 = "._2hwxidpf{margin-right:0}";
const _18 = "._19pkidpf{margin-top:0}";
const _17 = "._4t3i1lit{height:10pc}";
const _16 = "._4t3i68cl{height:90pt}";
const _15 = "._p12f1ba3{max-width:32.25rem}";
const _14 = "._y3gn1h6o{text-align:center}";
const _13 = "._18u01wug{margin-left:auto}";
const _12 = "._otyr1wug{margin-bottom:auto}";
const _11 = "._2hwx1wug{margin-right:auto}";
const _10 = "._19pk1wug{margin-top:auto}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BodyNormal, H5 } from '../../Typography';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _9 = "._2lx21bp4{flex-direction:column}";
const _8 = "._4cvr1h6o{align-items:center}";
const _7 = "._1bah1h6o{justify-content:center}";
const _6 = "._1e0c1txw{display:flex}";
const _5 = "._4t3i1osq{height:100%}";
const _4 = "._1bsb1osq{width:100%}";
const _3 = "._i0dlf1ug{flex-basis:0%}";
const _2 = "._1o9zkb7n{flex-shrink:1}";
const _ = "._16jlkb7n{flex-grow:1}";
export const ErrorTemplateStyled = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ErrorTemplateStyled.displayName = 'ErrorTemplateStyled';
}
export const ErrorViewInner = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_10, _11, _12, _13, _14, _15]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pk1wug _2hwx1wug _otyr1wug _18u01wug _y3gn1h6o _p12f1ba3", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ErrorViewInner.displayName = 'ErrorViewInner';
}
export const ErrorViewImage = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_16, _17]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["", __cmplp.size === 'small' ? "_4t3i68cl" : "_4t3i1lit", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ErrorViewImage.displayName = 'ErrorViewImage';
}
export const Heading = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = H5,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_18, _19, _20, _21, _22, _23]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1dyznl7k _ca0qv47k", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Heading.displayName = 'Heading';
}
export const Body = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_18, _19, _20, _21, _24]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qu2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Body.displayName = 'Body';
}
export const TextContainer = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_14, _25]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_y3gn1h6o _1wyb1j6v", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TextContainer.displayName = 'TextContainer';
}
export const ErrorFooterStyled = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_26]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkv47k", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ErrorFooterStyled.displayName = 'ErrorFooterStyled';
}